import { useEffect } from "react";

// Warms the browser cache with the secondary-camera tutorial clip while the
// candidate works through the steps that come before it.
//
// The clip is served from a plain S3 origin with no CDN in front of it, so on a
// slow path it arrives slower than it plays and GatedTutorialVideo stalls its
// way through the whole thing. Consent and the mic/camera check sit between
// Welcome and the pairing step and cost the candidate a minute or two of dead
// time — this spends that time downloading.
//
// A detached element rather than a hidden one in the tree: nothing here affects
// layout or re-renders, and there is no JSX to keep in sync. fetch() is not an
// option — the bucket serves no CORS headers, so a cross-origin fetch is
// blocked, while a media element loads cross-origin without them.
export const useTutorialPrefetch = (src, enabled) => {
  useEffect(() => {
    if (!enabled || !src) return;

    const video = document.createElement("video");
    video.preload = "auto";
    video.muted = true; // belt and braces — a detached element can't autoplay anyway
    video.playsInline = true;
    video.src = src;
    video.load();

    return () => {
      // Drop the source so the download is abandoned rather than left running
      // against a page that no longer needs it. Whatever already landed stays
      // in the HTTP cache for the real player to pick up.
      video.removeAttribute("src");
      video.load();
    };
  }, [src, enabled]);
};

export default useTutorialPrefetch;
